module.exports = __webpack_public_path__ + "media/images/dashboard/light/tile_icon_realtime_call_count-86673279c83fd2676a8a085f313cf11a.png";